import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Req = {
  contactId: number;
  contactInfoId: number;
  userId: string;
};

type Return = {
  deleteCustomerContactInfo: (req: Req) => Promise<void>;
  isDeleting: boolean;
};

export const useDeleteCustomerContactInfo = (): Return => {
  const { contactsApi } = useApiClient();
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation<void, Return, Req>({
    mutationFn: async req => {
      await contactsApi.deleteContactInfo(req.userId, req.contactId, req.contactInfoId);
    },
    onSuccess: async (_data, req) => {
      await queryClient.refetchQueries({
        queryKey: [QueryKeyEnum.CONTACTS.DETAILS, req.contactId],
      });
    },
  });

  return {
    deleteCustomerContactInfo: mutateAsync,
    isDeleting: isPending,
  };
};
